import { TMenuIds } from "../../../../app/state/menuSlice/types";
import { MenuBasic } from "../../../../common/Components/Menu/MenuBasic";
import { AppMenuItem } from "../../../../shared/components/AppMenu/AppMenuItem";
import { useImportSchemaMenu } from "../../hooks/use-import-schema-menu";
import styles from "./styles.module.css";

interface Props {
  loadXml: (xml: string) => void;
  closeMenu: (id: TMenuIds) => void;
}

export const ImportDrawIoSchemaMenu = ({ loadXml, closeMenu }: Props) => {
  const { importSchema, filteredSchemas, handleImportSchema } =
    useImportSchemaMenu(loadXml);

  return (
    <MenuBasic
      isOpen={importSchema.isOpen}
      position={importSchema.position}
      anchorPosition={{
        left: importSchema.position?.x ?? 0,
        top: importSchema.position?.y ?? 0,
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      onClose={() => {
        closeMenu("import_drawio_schema_menu");
      }}
    >
      {filteredSchemas.map((schema) => (
        <AppMenuItem
          key={schema.id}
          onClick={() => {
            handleImportSchema(
              schema?.value?.userfiles?.hash,
              schema?.value?.userfiles?.filename,
            );
            closeMenu("import_drawio_schema_menu");
          }}
          className={styles["menu-item"]}
        >
          {schema.friendly_name}
        </AppMenuItem>
      ))}
    </MenuBasic>
  );
};
